<form fxFlex [formGroup]="teamForm" (ngSubmit)="submit()">
  <mat-form-field fxFlex>
    <mat-label>Name</mat-label>
    <input matInput required formControlName="name" />
  </mat-form-field>

  <button type="submit"></button>
</form>
